import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
}

export enum GQLAcquisitionFrom {
  EmailFromRenatech = 'EmailFromRenatech',
  HospitalOrClinic = 'HospitalOrClinic',
  Introduce = 'Introduce',
  MailFromRenatech = 'MailFromRenatech',
  Media = 'Media',
  Other = 'Other',
  OtherAd = 'OtherAd',
  PaperAd = 'PaperAd',
  RadioOrTvOrYoutube = 'RadioOrTvOrYoutube',
  WebAd = 'WebAd',
  WebSearch = 'WebSearch',
  WebSite = 'WebSite'
}

export enum GQLChueiBankMemberType {
  Nenkin = 'Nenkin',
  Syokuiki = 'Syokuiki'
}

export interface GQLCouponCode {
  __typename?: 'CouponCode';
  code: Scalars['String']['output'];
  courseCode: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  disabled: Scalars['Boolean']['output'];
  expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  testPlaces: Array<GQLTestPlace>;
  updatedAt: Scalars['DateTimeISO']['output'];
}

export interface GQLCouponCodeInput {
  code: Scalars['String']['input'];
}

export interface GQLCouponCodesInput {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface GQLCreateCouponCodeInput {
  code: Scalars['String']['input'];
  courseCode: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  testPlaceIds: Array<Scalars['ID']['input']>;
}

export interface GQLCreateEntryInput {
  acquisitionFrom?: InputMaybe<GQLAcquisitionFrom>;
  acquisitionFromAdMedia?: InputMaybe<Scalars['String']['input']>;
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  affiliateTag?: InputMaybe<Scalars['String']['input']>;
  antiCovid19Test: Scalars['Boolean']['input'];
  birthday: Scalars['DateTimeISO']['input'];
  chueiBankMemberType?: InputMaybe<GQLChueiBankMemberType>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  genovisionCode?: InputMaybe<Scalars['String']['input']>;
  genovisionType?: InputMaybe<Scalars['Int']['input']>;
  goldenLoopType?: InputMaybe<Scalars['Float']['input']>;
  groupCode?: InputMaybe<Scalars['String']['input']>;
  hasEntryBefore: Scalars['Boolean']['input'];
  introducerId: Scalars['String']['input'];
  kyofukuMemberId?: InputMaybe<Scalars['String']['input']>;
  kyofukuMemberName?: InputMaybe<Scalars['String']['input']>;
  kyofukuMemberType?: InputMaybe<GQLKyofukuMemberType>;
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  lastTestDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lastTestPlaceId?: InputMaybe<Scalars['ID']['input']>;
  mbClubMemberId?: InputMaybe<Scalars['String']['input']>;
  mbClubPaymentMethod?: InputMaybe<GQLPaymentMethod>;
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  placeTag?: InputMaybe<Scalars['String']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  riebeUnionName?: InputMaybe<Scalars['String']['input']>;
  sapporoChushoMemberId?: InputMaybe<Scalars['String']['input']>;
  sapporoChushoMemberName?: InputMaybe<Scalars['String']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  sex: GQLSex;
  testDateId: Scalars['ID']['input'];
  testType: GQLTestType;
  type: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
}

export interface GQLCreateTestDateInput {
  capacity: Scalars['Int']['input'];
  endDate: Scalars['DateTimeISO']['input'];
  hidden: Scalars['Boolean']['input'];
  otherPlatformEntryCount: Scalars['Int']['input'];
  startDate: Scalars['DateTimeISO']['input'];
  stopped: Scalars['Boolean']['input'];
  stoppedMessage: Scalars['String']['input'];
  testPlaceId: Scalars['ID']['input'];
}

export interface GQLCreateTestDatesInput {
  testDates: Array<GQLCreateTestDateInput>;
}

export interface GQLCreateTestPlaceInput {
  acceptA1: Scalars['Boolean']['input'];
  acceptA2: Scalars['Boolean']['input'];
  acceptAntiCovid19Test: Scalars['Boolean']['input'];
  acceptBenefit: Scalars['Boolean']['input'];
  acceptBohseiFree: Scalars['Boolean']['input'];
  acceptBohseiMb: Scalars['Boolean']['input'];
  acceptChueiBank: Scalars['Boolean']['input'];
  acceptGenovision: Scalars['Boolean']['input'];
  acceptGoldenLoop: Scalars['Boolean']['input'];
  acceptInsurance: Scalars['Boolean']['input'];
  acceptKyofuku: Scalars['Boolean']['input'];
  acceptMbClub: Scalars['Boolean']['input'];
  acceptPromotion: Scalars['Boolean']['input'];
  acceptReloClub: Scalars['Boolean']['input'];
  acceptRiebe: Scalars['Boolean']['input'];
  acceptSapporoChusho: Scalars['Boolean']['input'];
  acceptStandardFree: Scalars['Boolean']['input'];
  acceptStandardFreeLP: Scalars['Boolean']['input'];
  acceptStandardMb: Scalars['Boolean']['input'];
  access: Scalars['String']['input'];
  address: Scalars['String']['input'];
  adminNote: Scalars['String']['input'];
  clinicName: Scalars['String']['input'];
  detail: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  embeddedMapHtml: Scalars['String']['input'];
  entryDeadline: Scalars['Float']['input'];
  excelName: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
  identifyString: Scalars['String']['input'];
  mapUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  notifyEmailAddress?: InputMaybe<Scalars['String']['input']>;
  openWeekdaysInMonth: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  prefecture: GQLPrefecture;
  schedule: Scalars['String']['input'];
  urlString?: InputMaybe<Scalars['String']['input']>;
}

export interface GQLDeleteCouponCodeInput {
  code: Scalars['String']['input'];
}

export interface GQLDeleteEntryInput {
  id: Scalars['ID']['input'];
}

export interface GQLDeleteServiceCodesInput {
  serviceCodeIds: Array<Scalars['ID']['input']>;
}

export interface GQLDeleteTestDateInput {
  id: Scalars['ID']['input'];
}

export interface GQLDeleteTestDatesInput {
  ids: Array<Scalars['ID']['input']>;
}

export interface GQLDeleteTestPlaceInput {
  id: Scalars['ID']['input'];
}

export interface GQLDeleteTestPlacesInput {
  ids: Array<Scalars['ID']['input']>;
}

export interface GQLEntriesInput {
  count?: InputMaybe<Scalars['Int']['input']>;
  createdMax?: InputMaybe<Scalars['DateTimeISO']['input']>;
  createdMin?: InputMaybe<Scalars['DateTimeISO']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  minUpdateCount?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  prefectures?: InputMaybe<Array<GQLPrefecture>>;
  testPlaceId?: InputMaybe<Scalars['ID']['input']>;
  updatedMax?: InputMaybe<Scalars['DateTimeISO']['input']>;
  updatedMin?: InputMaybe<Scalars['DateTimeISO']['input']>;
}

export interface GQLEntry {
  __typename?: 'Entry';
  acquisitionFrom?: Maybe<GQLAcquisitionFrom>;
  acquisitionFromAdMedia?: Maybe<Scalars['String']['output']>;
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  affiliateTag?: Maybe<Scalars['String']['output']>;
  antiCovid19Test: Scalars['Boolean']['output'];
  birthday: Scalars['DateTimeISO']['output'];
  chueiBankMemberType?: Maybe<GQLChueiBankMemberType>;
  couponCode?: Maybe<Scalars['String']['output']>;
  courseCode: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  firstNameKana: Scalars['String']['output'];
  genovisionCode?: Maybe<Scalars['String']['output']>;
  genovisionType?: Maybe<Scalars['Int']['output']>;
  goldenLoopType?: Maybe<Scalars['Int']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  hasEntryBefore: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  introducerId: Scalars['String']['output'];
  kyofukuMemberId?: Maybe<Scalars['String']['output']>;
  kyofukuMemberName?: Maybe<Scalars['String']['output']>;
  kyofukuMemberType?: Maybe<GQLKyofukuMemberType>;
  lastName: Scalars['String']['output'];
  lastNameKana: Scalars['String']['output'];
  lastTestDate?: Maybe<Scalars['DateTimeISO']['output']>;
  lastTestPlace?: Maybe<GQLTestPlace>;
  lastTestPlaceId?: Maybe<Scalars['ID']['output']>;
  mbClubMemberId?: Maybe<Scalars['String']['output']>;
  mbClubPaymentMethod?: Maybe<GQLPaymentMethod>;
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  placeTag?: Maybe<Scalars['String']['output']>;
  promotionCode?: Maybe<Scalars['String']['output']>;
  riebeUnionName?: Maybe<Scalars['String']['output']>;
  sapporoChushoMemberId?: Maybe<Scalars['String']['output']>;
  sapporoChushoMemberName?: Maybe<Scalars['String']['output']>;
  serviceCode?: Maybe<Scalars['String']['output']>;
  sex: GQLSex;
  testDate: GQLTestDate;
  testDateId: Scalars['ID']['output'];
  testType: GQLTestType;
  type: Scalars['String']['output'];
  updateCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  zipcode: Scalars['String']['output'];
}

export interface GQLEntryTestDateInput {
  entryId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
}

export interface GQLGroupCode {
  __typename?: 'GroupCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  name: Scalars['String']['output'];
}

export interface GQLIsValidGroupCodeInput {
  code: Scalars['String']['input'];
}

export interface GQLIsValidServiceCodeInput {
  serviceCode: Scalars['String']['input'];
}

export enum GQLKyofukuMemberType {
  Companion = 'Companion',
  Continuation = 'Continuation',
  Current = 'Current',
  Current2 = 'Current2'
}

export interface GQLMutation {
  __typename?: 'Mutation';
  createCouponCode: GQLCouponCode;
  createEntry: GQLEntry;
  createTestDate: GQLTestDate;
  createTestDates: Array<GQLTestDate>;
  createTestPlace: GQLTestPlace;
  deleteCouponCode?: Maybe<GQLCouponCode>;
  deleteEntry?: Maybe<GQLEntry>;
  deleteServiceCodes: Array<Scalars['ID']['output']>;
  deleteSetting: Scalars['Boolean']['output'];
  deleteTestDate?: Maybe<GQLTestDate>;
  deleteTestDates: Array<Scalars['ID']['output']>;
  deleteTestPlace?: Maybe<GQLTestPlace>;
  deleteTestPlaces?: Maybe<Array<GQLTestPlace>>;
  registerServiceCodes: Array<GQLServiceCode>;
  updateCouponCode: GQLCouponCode;
  updateEntry: GQLEntry;
  updateEntryTestDate: GQLTestDate;
  updateSetting: GQLSetting;
  updateTestDate: GQLTestDate;
  updateTestDates: Array<GQLTestDate>;
  updateTestPlace: GQLTestPlace;
}


export interface GQLMutationCreateCouponCodeArgs {
  input: GQLCreateCouponCodeInput;
}


export interface GQLMutationCreateEntryArgs {
  input: GQLCreateEntryInput;
}


export interface GQLMutationCreateTestDateArgs {
  input: GQLCreateTestDateInput;
}


export interface GQLMutationCreateTestDatesArgs {
  input: GQLCreateTestDatesInput;
}


export interface GQLMutationCreateTestPlaceArgs {
  input: GQLCreateTestPlaceInput;
}


export interface GQLMutationDeleteCouponCodeArgs {
  input: GQLDeleteCouponCodeInput;
}


export interface GQLMutationDeleteEntryArgs {
  input: GQLDeleteEntryInput;
}


export interface GQLMutationDeleteServiceCodesArgs {
  input: GQLDeleteServiceCodesInput;
}


export interface GQLMutationDeleteSettingArgs {
  input: GQLSettingInput;
}


export interface GQLMutationDeleteTestDateArgs {
  input: GQLDeleteTestDateInput;
}


export interface GQLMutationDeleteTestDatesArgs {
  input: GQLDeleteTestDatesInput;
}


export interface GQLMutationDeleteTestPlaceArgs {
  input: GQLDeleteTestPlaceInput;
}


export interface GQLMutationDeleteTestPlacesArgs {
  input: GQLDeleteTestPlacesInput;
}


export interface GQLMutationRegisterServiceCodesArgs {
  input: GQLRegisterServiceCodesInput;
}


export interface GQLMutationUpdateCouponCodeArgs {
  input: GQLUpdateCouponCodeInput;
}


export interface GQLMutationUpdateEntryArgs {
  input: GQLUpdateEntryInput;
}


export interface GQLMutationUpdateEntryTestDateArgs {
  input: GQLUpdateEntryTestDateInput;
}


export interface GQLMutationUpdateSettingArgs {
  input: GQLUpdateSettingInput;
}


export interface GQLMutationUpdateTestDateArgs {
  input: GQLUpdateTestDateInput;
}


export interface GQLMutationUpdateTestDatesArgs {
  input: GQLUpdateTestDatesInput;
}


export interface GQLMutationUpdateTestPlaceArgs {
  input: GQLUpdateTestPlaceInput;
}

export interface GQLPaginatedEntries {
  __typename?: 'PaginatedEntries';
  count: Scalars['Int']['output'];
  nodes: Array<GQLEntry>;
}

export interface GQLPaginatedServiceCodes {
  __typename?: 'PaginatedServiceCodes';
  count: Scalars['Int']['output'];
  nodes: Array<GQLServiceCode>;
}

export enum GQLPaymentMethod {
  Credit = 'Credit',
  Debit = 'Debit'
}

export enum GQLPrefecture {
  Aichi = 'Aichi',
  Akita = 'Akita',
  Aomori = 'Aomori',
  Chiba = 'Chiba',
  Ehime = 'Ehime',
  Fukui = 'Fukui',
  Fukuoka = 'Fukuoka',
  Fukushima = 'Fukushima',
  Gifu = 'Gifu',
  Gumma = 'Gumma',
  Hiroshima = 'Hiroshima',
  Hokkaido = 'Hokkaido',
  Hyogo = 'Hyogo',
  Ibaraki = 'Ibaraki',
  Ishikawa = 'Ishikawa',
  Iwate = 'Iwate',
  Kagawa = 'Kagawa',
  Kagoshima = 'Kagoshima',
  Kanagawa = 'Kanagawa',
  Kochi = 'Kochi',
  Kumamoto = 'Kumamoto',
  Kyoto = 'Kyoto',
  Mie = 'Mie',
  Miyagi = 'Miyagi',
  Miyazaki = 'Miyazaki',
  Nagano = 'Nagano',
  Nagasaki = 'Nagasaki',
  Nara = 'Nara',
  Niigata = 'Niigata',
  Oita = 'Oita',
  Okayama = 'Okayama',
  Okinawa = 'Okinawa',
  Osaka = 'Osaka',
  Saga = 'Saga',
  Saitama = 'Saitama',
  Shiga = 'Shiga',
  Shimane = 'Shimane',
  Shizuoka = 'Shizuoka',
  Tochigi = 'Tochigi',
  Tokushima = 'Tokushima',
  Tokyo = 'Tokyo',
  Tottori = 'Tottori',
  Toyama = 'Toyama',
  Wakayama = 'Wakayama',
  Yamagata = 'Yamagata',
  Yamaguchi = 'Yamaguchi',
  Yamanashi = 'Yamanashi'
}

export interface GQLQuery {
  __typename?: 'Query';
  couponCode: GQLCouponCode;
  couponCodes: Array<GQLCouponCode>;
  entries: GQLPaginatedEntries;
  entryTestDate: GQLTestDate;
  fullTestDates: Array<GQLTestDate>;
  fullTestPlaces: Array<GQLTestPlace>;
  groupCodes: Array<GQLGroupCode>;
  isValidGroupCode: Scalars['Boolean']['output'];
  isValidServiceCode: Scalars['Boolean']['output'];
  serviceCodes: GQLPaginatedServiceCodes;
  setting: GQLSetting;
  settings: Array<GQLSetting>;
  testDates: Array<GQLTestDate>;
  testPlaces: Array<GQLTestPlace>;
}


export interface GQLQueryCouponCodeArgs {
  input: GQLCouponCodeInput;
}


export interface GQLQueryCouponCodesArgs {
  input: GQLCouponCodesInput;
}


export interface GQLQueryEntriesArgs {
  input: GQLEntriesInput;
}


export interface GQLQueryEntryTestDateArgs {
  input: GQLEntryTestDateInput;
}


export interface GQLQueryFullTestDatesArgs {
  testPlaceId?: InputMaybe<Scalars['ID']['input']>;
}


export interface GQLQueryIsValidGroupCodeArgs {
  input: GQLIsValidGroupCodeInput;
}


export interface GQLQueryIsValidServiceCodeArgs {
  input: GQLIsValidServiceCodeInput;
}


export interface GQLQueryServiceCodesArgs {
  input: GQLServiceCodesInput;
}


export interface GQLQuerySettingArgs {
  input: GQLSettingInput;
}


export interface GQLQueryTestDatesArgs {
  testPlaceId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GQLRegisterServiceCodeInput {
  code: Scalars['ID']['input'];
  expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  used?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface GQLRegisterServiceCodesInput {
  serviceCodes: Array<GQLRegisterServiceCodeInput>;
}

export interface GQLServiceCode {
  __typename?: 'ServiceCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  entryId?: Maybe<Scalars['ID']['output']>;
  expirationDate?: Maybe<Scalars['DateTimeISO']['output']>;
  used: Scalars['Boolean']['output'];
  usedAt?: Maybe<Scalars['DateTimeISO']['output']>;
}

export interface GQLServiceCodesInput {
  count?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GQLSetting {
  __typename?: 'Setting';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface GQLSettingInput {
  id: Scalars['String']['input'];
}

export enum GQLSex {
  Female = 'Female',
  Male = 'Male'
}

export interface GQLTestDate {
  __typename?: 'TestDate';
  capacity: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deleted: Scalars['Boolean']['output'];
  endDate: Scalars['DateTimeISO']['output'];
  entries: Array<GQLEntry>;
  entryCount: Scalars['Float']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  otherPlatformEntryCount: Scalars['Int']['output'];
  startDate: Scalars['DateTimeISO']['output'];
  stopped: Scalars['Boolean']['output'];
  stoppedMessage: Scalars['String']['output'];
  testPlace: GQLTestPlace;
  testPlaceId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
}

export interface GQLTestPlace {
  __typename?: 'TestPlace';
  acceptA1: Scalars['Boolean']['output'];
  acceptA2: Scalars['Boolean']['output'];
  acceptAntiCovid19Test: Scalars['Boolean']['output'];
  acceptBenefit: Scalars['Boolean']['output'];
  acceptBohseiFree: Scalars['Boolean']['output'];
  acceptBohseiMb: Scalars['Boolean']['output'];
  acceptChueiBank: Scalars['Boolean']['output'];
  acceptGenovision: Scalars['Boolean']['output'];
  acceptGoldenLoop: Scalars['Boolean']['output'];
  acceptInsurance: Scalars['Boolean']['output'];
  acceptKyofuku: Scalars['Boolean']['output'];
  acceptMbClub: Scalars['Boolean']['output'];
  acceptPromotion: Scalars['Boolean']['output'];
  acceptReloClub: Scalars['Boolean']['output'];
  acceptRiebe: Scalars['Boolean']['output'];
  acceptSapporoChusho: Scalars['Boolean']['output'];
  acceptStandardFree: Scalars['Boolean']['output'];
  acceptStandardFreeLP: Scalars['Boolean']['output'];
  acceptStandardMb: Scalars['Boolean']['output'];
  access: Scalars['String']['output'];
  address: Scalars['String']['output'];
  adminNote: Scalars['String']['output'];
  availableTestDateCount: Scalars['Float']['output'];
  availableV1TestDateCount: Scalars['Float']['output'];
  availableV2TestDateCount: Scalars['Float']['output'];
  clinicName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  deleted: Scalars['Boolean']['output'];
  detail: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  embeddedMapHtml: Scalars['String']['output'];
  entryDeadline: Scalars['Float']['output'];
  excelName: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifyString: Scalars['String']['output'];
  mapUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  notifyEmailAddress?: Maybe<Scalars['String']['output']>;
  openWeekdaysInMonth: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  prefecture: GQLPrefecture;
  schedule: Scalars['String']['output'];
  testDateCount: Scalars['Float']['output'];
  testDates: Array<GQLTestDate>;
  updatedAt: Scalars['DateTimeISO']['output'];
  urlString?: Maybe<Scalars['String']['output']>;
}

export enum GQLTestType {
  Benefit = 'Benefit',
  BohseiFree = 'BohseiFree',
  BohseiMb = 'BohseiMB',
  ChueiBank = 'ChueiBank',
  Coupon = 'Coupon',
  Genovision = 'Genovision',
  GoldenLoop = 'GoldenLoop',
  Insurance = 'Insurance',
  Kyofuku = 'Kyofuku',
  MbClub = 'MbClub',
  OldStandardMb = 'OldStandardMb',
  OldTrialMbWithCohort = 'OldTrialMbWithCohort',
  OldTriallMb = 'OldTriallMb',
  Promotion = 'Promotion',
  ReloClub = 'ReloClub',
  Riebe = 'Riebe',
  SapporoChusho = 'SapporoChusho',
  StandardFree = 'StandardFree',
  StandardFreeLp = 'StandardFreeLP',
  StandardMb = 'StandardMb'
}

export interface GQLUpdateCouponCodeInput {
  code: Scalars['String']['input'];
  courseCode: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  expirationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  testPlaceIds: Array<Scalars['ID']['input']>;
}

export interface GQLUpdateEntryInput {
  acquisitionFrom?: InputMaybe<GQLAcquisitionFrom>;
  acquisitionFromAdMedia?: InputMaybe<Scalars['String']['input']>;
  address1: Scalars['String']['input'];
  address2: Scalars['String']['input'];
  affiliateTag?: InputMaybe<Scalars['String']['input']>;
  antiCovid19Test: Scalars['Boolean']['input'];
  birthday: Scalars['DateTimeISO']['input'];
  chueiBankMemberType?: InputMaybe<GQLChueiBankMemberType>;
  couponCode?: InputMaybe<Scalars['String']['input']>;
  courseCode: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  firstNameKana: Scalars['String']['input'];
  genovisionCode?: InputMaybe<Scalars['String']['input']>;
  genovisionType?: InputMaybe<Scalars['Int']['input']>;
  goldenLoopType?: InputMaybe<Scalars['Float']['input']>;
  groupCode?: InputMaybe<Scalars['String']['input']>;
  hasEntryBefore: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  introducerId: Scalars['String']['input'];
  kyofukuMemberId?: InputMaybe<Scalars['String']['input']>;
  kyofukuMemberName?: InputMaybe<Scalars['String']['input']>;
  kyofukuMemberType?: InputMaybe<GQLKyofukuMemberType>;
  lastName: Scalars['String']['input'];
  lastNameKana: Scalars['String']['input'];
  lastTestDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  lastTestPlaceId?: InputMaybe<Scalars['ID']['input']>;
  mbClubMemberId?: InputMaybe<Scalars['String']['input']>;
  mbClubPaymentMethod?: InputMaybe<GQLPaymentMethod>;
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  placeTag?: InputMaybe<Scalars['String']['input']>;
  promotionCode?: InputMaybe<Scalars['String']['input']>;
  riebeUnionName?: InputMaybe<Scalars['String']['input']>;
  sapporoChushoMemberId?: InputMaybe<Scalars['String']['input']>;
  sapporoChushoMemberName?: InputMaybe<Scalars['String']['input']>;
  serviceCode?: InputMaybe<Scalars['String']['input']>;
  sex: GQLSex;
  testDateId: Scalars['ID']['input'];
  testType: GQLTestType;
  type: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
}

export interface GQLUpdateEntryTestDateInput {
  entryId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
  testDateId: Scalars['ID']['input'];
}

export interface GQLUpdateSettingInput {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export interface GQLUpdateTestDateInput {
  capacity: Scalars['Int']['input'];
  endDate: Scalars['DateTimeISO']['input'];
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  otherPlatformEntryCount: Scalars['Int']['input'];
  startDate: Scalars['DateTimeISO']['input'];
  stopped: Scalars['Boolean']['input'];
  stoppedMessage: Scalars['String']['input'];
  testPlaceId: Scalars['ID']['input'];
}

export interface GQLUpdateTestDatesInput {
  testDates: Array<GQLUpdateTestDateInput>;
}

export interface GQLUpdateTestPlaceInput {
  acceptA1: Scalars['Boolean']['input'];
  acceptA2: Scalars['Boolean']['input'];
  acceptAntiCovid19Test: Scalars['Boolean']['input'];
  acceptBenefit: Scalars['Boolean']['input'];
  acceptBohseiFree: Scalars['Boolean']['input'];
  acceptBohseiMb: Scalars['Boolean']['input'];
  acceptChueiBank: Scalars['Boolean']['input'];
  acceptGenovision: Scalars['Boolean']['input'];
  acceptGoldenLoop: Scalars['Boolean']['input'];
  acceptInsurance: Scalars['Boolean']['input'];
  acceptKyofuku: Scalars['Boolean']['input'];
  acceptMbClub: Scalars['Boolean']['input'];
  acceptPromotion: Scalars['Boolean']['input'];
  acceptReloClub: Scalars['Boolean']['input'];
  acceptRiebe: Scalars['Boolean']['input'];
  acceptSapporoChusho: Scalars['Boolean']['input'];
  acceptStandardFree: Scalars['Boolean']['input'];
  acceptStandardFreeLP: Scalars['Boolean']['input'];
  acceptStandardMb: Scalars['Boolean']['input'];
  access: Scalars['String']['input'];
  address: Scalars['String']['input'];
  adminNote: Scalars['String']['input'];
  clinicName: Scalars['String']['input'];
  detail: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  embeddedMapHtml: Scalars['String']['input'];
  entryDeadline: Scalars['Float']['input'];
  excelName: Scalars['String']['input'];
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  identifyString: Scalars['String']['input'];
  mapUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  notifyEmailAddress?: InputMaybe<Scalars['String']['input']>;
  openWeekdaysInMonth: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  prefecture: GQLPrefecture;
  schedule: Scalars['String']['input'];
  urlString?: InputMaybe<Scalars['String']['input']>;
}

export type GQLEntryFragment = { __typename?: 'Entry', id: string, testType: GQLTestType, firstName: string, lastName: string, firstNameKana: string, lastNameKana: string, sex: GQLSex, birthday: any, zipcode: string, address1: string, address2: string, phoneNumber: string, email: string, introducerId: string, affiliateTag?: string | null, placeTag?: string | null, acquisitionFrom?: GQLAcquisitionFrom | null, acquisitionFromAdMedia?: string | null, message?: string | null, createdAt: any, updatedAt: any, kyofukuMemberType?: GQLKyofukuMemberType | null, kyofukuMemberId?: string | null, kyofukuMemberName?: string | null, mbClubPaymentMethod?: GQLPaymentMethod | null, mbClubMemberId?: string | null, lastTestDate?: any | null, promotionCode?: string | null, riebeUnionName?: string | null, chueiBankMemberType?: GQLChueiBankMemberType | null, sapporoChushoMemberId?: string | null, sapporoChushoMemberName?: string | null, genovisionType?: number | null, genovisionCode?: string | null, antiCovid19Test: boolean, testDateId: string, lastTestPlaceId?: string | null, hasEntryBefore: boolean, serviceCode?: string | null, groupCode?: string | null, updateCount: number, type: string, courseCode: number, goldenLoopType?: number | null, couponCode?: string | null };

export type GQLTestDateFragment = { __typename?: 'TestDate', id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number };

export type GQLFullTestDateFragment = { __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number };

export type GQLTestPlaceFragment = { __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string };

export type GQLFullTestPlaceFragment = { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string };

export type GQLServiceCodeFragment = { __typename?: 'ServiceCode', code: string, used: boolean, entryId?: string | null, expirationDate?: any | null, createdAt: any, usedAt?: any | null };

export type GQLCouponCodeFragment = { __typename?: 'CouponCode', code: string, name: string, courseCode: string, startDate?: any | null, expirationDate?: any | null, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> };

export type GQLFullCouponCodeFragment = { __typename?: 'CouponCode', startDate?: any | null, expirationDate?: any | null, note: string, disabled: boolean, code: string, name: string, courseCode: string, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> };

export type GQLSettingFragment = { __typename?: 'Setting', id: string, value: string };

export type GQLCreateEntryMutationVariables = Exact<{
  input: GQLCreateEntryInput;
}>;


export type GQLCreateEntryMutation = { __typename?: 'Mutation', createEntry: { __typename?: 'Entry', id: string, testType: GQLTestType, firstName: string, lastName: string, firstNameKana: string, lastNameKana: string, sex: GQLSex, birthday: any, zipcode: string, address1: string, address2: string, phoneNumber: string, email: string, introducerId: string, affiliateTag?: string | null, placeTag?: string | null, acquisitionFrom?: GQLAcquisitionFrom | null, acquisitionFromAdMedia?: string | null, message?: string | null, createdAt: any, updatedAt: any, kyofukuMemberType?: GQLKyofukuMemberType | null, kyofukuMemberId?: string | null, kyofukuMemberName?: string | null, mbClubPaymentMethod?: GQLPaymentMethod | null, mbClubMemberId?: string | null, lastTestDate?: any | null, promotionCode?: string | null, riebeUnionName?: string | null, chueiBankMemberType?: GQLChueiBankMemberType | null, sapporoChushoMemberId?: string | null, sapporoChushoMemberName?: string | null, genovisionType?: number | null, genovisionCode?: string | null, antiCovid19Test: boolean, testDateId: string, lastTestPlaceId?: string | null, hasEntryBefore: boolean, serviceCode?: string | null, groupCode?: string | null, updateCount: number, type: string, courseCode: number, goldenLoopType?: number | null, couponCode?: string | null, testDate: { __typename?: 'TestDate', id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number, testPlace: { __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string } } } };

export type GQLUpdateEntryMutationVariables = Exact<{
  input: GQLUpdateEntryInput;
}>;


export type GQLUpdateEntryMutation = { __typename?: 'Mutation', updateEntry: { __typename?: 'Entry', id: string, testType: GQLTestType, firstName: string, lastName: string, firstNameKana: string, lastNameKana: string, sex: GQLSex, birthday: any, zipcode: string, address1: string, address2: string, phoneNumber: string, email: string, introducerId: string, affiliateTag?: string | null, placeTag?: string | null, acquisitionFrom?: GQLAcquisitionFrom | null, acquisitionFromAdMedia?: string | null, message?: string | null, createdAt: any, updatedAt: any, kyofukuMemberType?: GQLKyofukuMemberType | null, kyofukuMemberId?: string | null, kyofukuMemberName?: string | null, mbClubPaymentMethod?: GQLPaymentMethod | null, mbClubMemberId?: string | null, lastTestDate?: any | null, promotionCode?: string | null, riebeUnionName?: string | null, chueiBankMemberType?: GQLChueiBankMemberType | null, sapporoChushoMemberId?: string | null, sapporoChushoMemberName?: string | null, genovisionType?: number | null, genovisionCode?: string | null, antiCovid19Test: boolean, testDateId: string, lastTestPlaceId?: string | null, hasEntryBefore: boolean, serviceCode?: string | null, groupCode?: string | null, updateCount: number, type: string, courseCode: number, goldenLoopType?: number | null, couponCode?: string | null, testDate: { __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number, testPlace: { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string } } } };

export type GQLDeleteEntryMutationVariables = Exact<{
  input: GQLDeleteEntryInput;
}>;


export type GQLDeleteEntryMutation = { __typename?: 'Mutation', deleteEntry?: { __typename?: 'Entry', id: string, testType: GQLTestType, firstName: string, lastName: string, firstNameKana: string, lastNameKana: string, sex: GQLSex, birthday: any, zipcode: string, address1: string, address2: string, phoneNumber: string, email: string, introducerId: string, affiliateTag?: string | null, placeTag?: string | null, acquisitionFrom?: GQLAcquisitionFrom | null, acquisitionFromAdMedia?: string | null, message?: string | null, createdAt: any, updatedAt: any, kyofukuMemberType?: GQLKyofukuMemberType | null, kyofukuMemberId?: string | null, kyofukuMemberName?: string | null, mbClubPaymentMethod?: GQLPaymentMethod | null, mbClubMemberId?: string | null, lastTestDate?: any | null, promotionCode?: string | null, riebeUnionName?: string | null, chueiBankMemberType?: GQLChueiBankMemberType | null, sapporoChushoMemberId?: string | null, sapporoChushoMemberName?: string | null, genovisionType?: number | null, genovisionCode?: string | null, antiCovid19Test: boolean, testDateId: string, lastTestPlaceId?: string | null, hasEntryBefore: boolean, serviceCode?: string | null, groupCode?: string | null, updateCount: number, type: string, courseCode: number, goldenLoopType?: number | null, couponCode?: string | null } | null };

export type GQLCreateTestPlaceMutationVariables = Exact<{
  input: GQLCreateTestPlaceInput;
}>;


export type GQLCreateTestPlaceMutation = { __typename?: 'Mutation', createTestPlace: { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string, testDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> } };

export type GQLUpdateTestPlaceMutationVariables = Exact<{
  input: GQLUpdateTestPlaceInput;
}>;


export type GQLUpdateTestPlaceMutation = { __typename?: 'Mutation', updateTestPlace: { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string, testDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> } };

export type GQLDeleteTestPlaceMutationVariables = Exact<{
  input: GQLDeleteTestPlaceInput;
}>;


export type GQLDeleteTestPlaceMutation = { __typename?: 'Mutation', deleteTestPlace?: { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string, testDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> } | null };

export type GQLDeleteTestPlacesMutationVariables = Exact<{
  input: GQLDeleteTestPlacesInput;
}>;


export type GQLDeleteTestPlacesMutation = { __typename?: 'Mutation', deleteTestPlaces?: Array<{ __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string, testDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> }> | null };

export type GQLCreateTestDateMutationVariables = Exact<{
  input: GQLCreateTestDateInput;
}>;


export type GQLCreateTestDateMutation = { __typename?: 'Mutation', createTestDate: { __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number } };

export type GQLCreateTestDatesMutationVariables = Exact<{
  input: GQLCreateTestDatesInput;
}>;


export type GQLCreateTestDatesMutation = { __typename?: 'Mutation', createTestDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> };

export type GQLUpdateTestDateMutationVariables = Exact<{
  input: GQLUpdateTestDateInput;
}>;


export type GQLUpdateTestDateMutation = { __typename?: 'Mutation', updateTestDate: { __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number } };

export type GQLUpdateTestDatesMutationVariables = Exact<{
  input: GQLUpdateTestDatesInput;
}>;


export type GQLUpdateTestDatesMutation = { __typename?: 'Mutation', updateTestDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> };

export type GQLDeleteTestdateMutationVariables = Exact<{
  input: GQLDeleteTestDateInput;
}>;


export type GQLDeleteTestdateMutation = { __typename?: 'Mutation', deleteTestDate?: { __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number } | null };

export type GQLDeleteTestdatesMutationVariables = Exact<{
  input: GQLDeleteTestDatesInput;
}>;


export type GQLDeleteTestdatesMutation = { __typename?: 'Mutation', deleteTestDates: Array<string> };

export type GQLRegisterServiceCodesMutationVariables = Exact<{
  input: GQLRegisterServiceCodesInput;
}>;


export type GQLRegisterServiceCodesMutation = { __typename?: 'Mutation', registerServiceCodes: Array<{ __typename?: 'ServiceCode', code: string, used: boolean, entryId?: string | null, expirationDate?: any | null, createdAt: any, usedAt?: any | null }> };

export type GQLDeleteServiceCodesMutationVariables = Exact<{
  input: GQLDeleteServiceCodesInput;
}>;


export type GQLDeleteServiceCodesMutation = { __typename?: 'Mutation', deleteServiceCodes: Array<string> };

export type GQLUpdateEntryTestDateMutationVariables = Exact<{
  input: GQLUpdateEntryTestDateInput;
}>;


export type GQLUpdateEntryTestDateMutation = { __typename?: 'Mutation', updateEntryTestDate: { __typename?: 'TestDate', id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number } };

export type GQLCreateCouponCodeMutationVariables = Exact<{
  input: GQLCreateCouponCodeInput;
}>;


export type GQLCreateCouponCodeMutation = { __typename?: 'Mutation', createCouponCode: { __typename?: 'CouponCode', code: string, name: string, courseCode: string, startDate?: any | null, expirationDate?: any | null, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> } };

export type GQLUpdateCouponCodeMutationVariables = Exact<{
  input: GQLUpdateCouponCodeInput;
}>;


export type GQLUpdateCouponCodeMutation = { __typename?: 'Mutation', updateCouponCode: { __typename?: 'CouponCode', code: string, name: string, courseCode: string, startDate?: any | null, expirationDate?: any | null, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> } };

export type GQLDeleteCouponCodeMutationVariables = Exact<{
  input: GQLDeleteCouponCodeInput;
}>;


export type GQLDeleteCouponCodeMutation = { __typename?: 'Mutation', deleteCouponCode?: { __typename?: 'CouponCode', code: string, name: string, courseCode: string, startDate?: any | null, expirationDate?: any | null, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> } | null };

export type GQLEntriesQueryVariables = Exact<{
  input: GQLEntriesInput;
}>;


export type GQLEntriesQuery = { __typename?: 'Query', entries: { __typename?: 'PaginatedEntries', count: number, nodes: Array<{ __typename?: 'Entry', id: string, testType: GQLTestType, firstName: string, lastName: string, firstNameKana: string, lastNameKana: string, sex: GQLSex, birthday: any, zipcode: string, address1: string, address2: string, phoneNumber: string, email: string, introducerId: string, affiliateTag?: string | null, placeTag?: string | null, acquisitionFrom?: GQLAcquisitionFrom | null, acquisitionFromAdMedia?: string | null, message?: string | null, createdAt: any, updatedAt: any, kyofukuMemberType?: GQLKyofukuMemberType | null, kyofukuMemberId?: string | null, kyofukuMemberName?: string | null, mbClubPaymentMethod?: GQLPaymentMethod | null, mbClubMemberId?: string | null, lastTestDate?: any | null, promotionCode?: string | null, riebeUnionName?: string | null, chueiBankMemberType?: GQLChueiBankMemberType | null, sapporoChushoMemberId?: string | null, sapporoChushoMemberName?: string | null, genovisionType?: number | null, genovisionCode?: string | null, antiCovid19Test: boolean, testDateId: string, lastTestPlaceId?: string | null, hasEntryBefore: boolean, serviceCode?: string | null, groupCode?: string | null, updateCount: number, type: string, courseCode: number, goldenLoopType?: number | null, couponCode?: string | null, testDate: { __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number, testPlace: { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string } }, lastTestPlace?: { __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string } | null }> } };

export type GQLTestPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLTestPlacesQuery = { __typename?: 'Query', testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> };

export type GQLTestDatesQueryVariables = Exact<{
  testPlaceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GQLTestDatesQuery = { __typename?: 'Query', testDates: Array<{ __typename?: 'TestDate', id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> };

export type GQLFullTestPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLFullTestPlacesQuery = { __typename?: 'Query', fullTestPlaces: Array<{ __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> };

export type GQLFullTestPlacesWithTestDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GQLFullTestPlacesWithTestDatesQuery = { __typename?: 'Query', fullTestPlaces: Array<{ __typename?: 'TestPlace', createdAt: any, updatedAt: any, hidden: boolean, deleted: boolean, notifyEmailAddress?: string | null, identifyString: string, excelName: string, entryDeadline: number, testDateCount: number, availableTestDateCount: number, adminNote: string, openWeekdaysInMonth: string, id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string, testDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> }> };

export type GQLFullTestDatesQueryVariables = Exact<{
  testPlaceId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GQLFullTestDatesQuery = { __typename?: 'Query', fullTestDates: Array<{ __typename?: 'TestDate', deleted: boolean, hidden: boolean, createdAt: any, updatedAt: any, id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number }> };

export type GQLServiceCodesQueryVariables = Exact<{
  input: GQLServiceCodesInput;
}>;


export type GQLServiceCodesQuery = { __typename?: 'Query', serviceCodes: { __typename?: 'PaginatedServiceCodes', count: number, nodes: Array<{ __typename?: 'ServiceCode', code: string, used: boolean, entryId?: string | null, expirationDate?: any | null, createdAt: any, usedAt?: any | null }> } };

export type GQLIsValidServiceCodeQueryVariables = Exact<{
  input: GQLIsValidServiceCodeInput;
}>;


export type GQLIsValidServiceCodeQuery = { __typename?: 'Query', isValidServiceCode: boolean };

export type GQLEntryTestDateQueryVariables = Exact<{
  input: GQLEntryTestDateInput;
}>;


export type GQLEntryTestDateQuery = { __typename?: 'Query', entryTestDate: { __typename?: 'TestDate', id: string, startDate: any, endDate: any, capacity: number, entryCount: number, testPlaceId: string, stopped: boolean, stoppedMessage: string, otherPlatformEntryCount: number, testPlace: { __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string } } };

export type GQLCouponCodeQueryVariables = Exact<{
  input: GQLCouponCodeInput;
}>;


export type GQLCouponCodeQuery = { __typename?: 'Query', couponCode: { __typename?: 'CouponCode', code: string, name: string, courseCode: string, startDate?: any | null, expirationDate?: any | null, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> } };

export type GQLCouponCodesQueryVariables = Exact<{
  input: GQLCouponCodesInput;
}>;


export type GQLCouponCodesQuery = { __typename?: 'Query', couponCodes: Array<{ __typename?: 'CouponCode', startDate?: any | null, expirationDate?: any | null, note: string, disabled: boolean, code: string, name: string, courseCode: string, testPlaces: Array<{ __typename?: 'TestPlace', id: string, name: string, clinicName: string, address: string, prefecture: GQLPrefecture, schedule: string, access: string, detail: string, mapUrl: string, embeddedMapHtml: string, disabled: boolean, order: number, acceptStandardFree: boolean, acceptStandardFreeLP: boolean, acceptStandardMb: boolean, acceptMbClub: boolean, acceptKyofuku: boolean, acceptChueiBank: boolean, acceptRiebe: boolean, acceptPromotion: boolean, acceptSapporoChusho: boolean, acceptBohseiMb: boolean, acceptBohseiFree: boolean, acceptInsurance: boolean, acceptGenovision: boolean, acceptReloClub: boolean, acceptBenefit: boolean, acceptA1: boolean, acceptA2: boolean, acceptAntiCovid19Test: boolean, acceptGoldenLoop: boolean, urlString?: string | null, note: string }> }> };

export type GQLSettingQueryVariables = Exact<{
  input: GQLSettingInput;
}>;


export type GQLSettingQuery = { __typename?: 'Query', setting: { __typename?: 'Setting', id: string, value: string } };

export const EntryFragmentDoc = gql`
    fragment Entry on Entry {
  id
  testType
  firstName
  lastName
  firstNameKana
  lastNameKana
  sex
  birthday
  zipcode
  address1
  address2
  phoneNumber
  email
  introducerId
  affiliateTag
  placeTag
  acquisitionFrom
  acquisitionFromAdMedia
  message
  createdAt
  updatedAt
  kyofukuMemberType
  kyofukuMemberId
  kyofukuMemberName
  mbClubPaymentMethod
  mbClubMemberId
  lastTestDate
  promotionCode
  riebeUnionName
  chueiBankMemberType
  sapporoChushoMemberId
  sapporoChushoMemberName
  genovisionType
  genovisionCode
  antiCovid19Test
  testDateId
  lastTestPlaceId
  hasEntryBefore
  serviceCode
  groupCode
  updateCount
  type
  courseCode
  goldenLoopType
  couponCode
}
    `;
export const TestDateFragmentDoc = gql`
    fragment TestDate on TestDate {
  id
  startDate
  endDate
  capacity
  entryCount
  testPlaceId
  stopped
  stoppedMessage
  otherPlatformEntryCount
}
    `;
export const FullTestDateFragmentDoc = gql`
    fragment FullTestDate on TestDate {
  ...TestDate
  deleted
  hidden
  createdAt
  updatedAt
}
    ${TestDateFragmentDoc}`;
export const TestPlaceFragmentDoc = gql`
    fragment TestPlace on TestPlace {
  id
  name
  clinicName
  address
  prefecture
  schedule
  access
  detail
  mapUrl
  embeddedMapHtml
  disabled
  order
  acceptStandardFree
  acceptStandardFreeLP
  acceptStandardMb
  acceptMbClub
  acceptKyofuku
  acceptChueiBank
  acceptRiebe
  acceptPromotion
  acceptSapporoChusho
  acceptBohseiMb
  acceptBohseiFree
  acceptInsurance
  acceptGenovision
  acceptReloClub
  acceptBenefit
  acceptA1
  acceptA2
  acceptAntiCovid19Test
  acceptGoldenLoop
  urlString
  note
}
    `;
export const FullTestPlaceFragmentDoc = gql`
    fragment FullTestPlace on TestPlace {
  ...TestPlace
  createdAt
  updatedAt
  hidden
  deleted
  notifyEmailAddress
  identifyString
  excelName
  entryDeadline
  testDateCount
  availableTestDateCount
  adminNote
  openWeekdaysInMonth
}
    ${TestPlaceFragmentDoc}`;
export const ServiceCodeFragmentDoc = gql`
    fragment ServiceCode on ServiceCode {
  code
  used
  entryId
  expirationDate
  createdAt
  usedAt
}
    `;
export const CouponCodeFragmentDoc = gql`
    fragment CouponCode on CouponCode {
  code
  name
  courseCode
  startDate
  expirationDate
  testPlaces {
    ...TestPlace
  }
}
    ${TestPlaceFragmentDoc}`;
export const FullCouponCodeFragmentDoc = gql`
    fragment FullCouponCode on CouponCode {
  ...CouponCode
  startDate
  expirationDate
  note
  disabled
  testPlaces {
    ...TestPlace
  }
}
    ${CouponCodeFragmentDoc}
${TestPlaceFragmentDoc}`;
export const SettingFragmentDoc = gql`
    fragment Setting on Setting {
  id
  value
}
    `;
export const CreateEntryDocument = gql`
    mutation createEntry($input: CreateEntryInput!) {
  createEntry(input: $input) {
    ...Entry
    testDate {
      ...TestDate
      testPlace {
        ...TestPlace
      }
    }
  }
}
    ${EntryFragmentDoc}
${TestDateFragmentDoc}
${TestPlaceFragmentDoc}`;
export type GQLCreateEntryMutationFn = Apollo.MutationFunction<GQLCreateEntryMutation, GQLCreateEntryMutationVariables>;

/**
 * __useCreateEntryMutation__
 *
 * To run a mutation, you first call `useCreateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntryMutation, { data, loading, error }] = useCreateEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEntryMutation(baseOptions?: Apollo.MutationHookOptions<GQLCreateEntryMutation, GQLCreateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLCreateEntryMutation, GQLCreateEntryMutationVariables>(CreateEntryDocument, options);
      }
export type CreateEntryMutationHookResult = ReturnType<typeof useCreateEntryMutation>;
export type CreateEntryMutationResult = Apollo.MutationResult<GQLCreateEntryMutation>;
export type CreateEntryMutationOptions = Apollo.BaseMutationOptions<GQLCreateEntryMutation, GQLCreateEntryMutationVariables>;
export const UpdateEntryDocument = gql`
    mutation updateEntry($input: UpdateEntryInput!) {
  updateEntry(input: $input) {
    ...Entry
    testDate {
      ...FullTestDate
      testPlace {
        ...FullTestPlace
      }
    }
  }
}
    ${EntryFragmentDoc}
${FullTestDateFragmentDoc}
${FullTestPlaceFragmentDoc}`;
export type GQLUpdateEntryMutationFn = Apollo.MutationFunction<GQLUpdateEntryMutation, GQLUpdateEntryMutationVariables>;

/**
 * __useUpdateEntryMutation__
 *
 * To run a mutation, you first call `useUpdateEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntryMutation, { data, loading, error }] = useUpdateEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntryMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateEntryMutation, GQLUpdateEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateEntryMutation, GQLUpdateEntryMutationVariables>(UpdateEntryDocument, options);
      }
export type UpdateEntryMutationHookResult = ReturnType<typeof useUpdateEntryMutation>;
export type UpdateEntryMutationResult = Apollo.MutationResult<GQLUpdateEntryMutation>;
export type UpdateEntryMutationOptions = Apollo.BaseMutationOptions<GQLUpdateEntryMutation, GQLUpdateEntryMutationVariables>;
export const DeleteEntryDocument = gql`
    mutation deleteEntry($input: DeleteEntryInput!) {
  deleteEntry(input: $input) {
    ...Entry
  }
}
    ${EntryFragmentDoc}`;
export type GQLDeleteEntryMutationFn = Apollo.MutationFunction<GQLDeleteEntryMutation, GQLDeleteEntryMutationVariables>;

/**
 * __useDeleteEntryMutation__
 *
 * To run a mutation, you first call `useDeleteEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntryMutation, { data, loading, error }] = useDeleteEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEntryMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteEntryMutation, GQLDeleteEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteEntryMutation, GQLDeleteEntryMutationVariables>(DeleteEntryDocument, options);
      }
export type DeleteEntryMutationHookResult = ReturnType<typeof useDeleteEntryMutation>;
export type DeleteEntryMutationResult = Apollo.MutationResult<GQLDeleteEntryMutation>;
export type DeleteEntryMutationOptions = Apollo.BaseMutationOptions<GQLDeleteEntryMutation, GQLDeleteEntryMutationVariables>;
export const CreateTestPlaceDocument = gql`
    mutation createTestPlace($input: CreateTestPlaceInput!) {
  createTestPlace(input: $input) {
    ...FullTestPlace
    testDates {
      ...FullTestDate
    }
  }
}
    ${FullTestPlaceFragmentDoc}
${FullTestDateFragmentDoc}`;
export type GQLCreateTestPlaceMutationFn = Apollo.MutationFunction<GQLCreateTestPlaceMutation, GQLCreateTestPlaceMutationVariables>;

/**
 * __useCreateTestPlaceMutation__
 *
 * To run a mutation, you first call `useCreateTestPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestPlaceMutation, { data, loading, error }] = useCreateTestPlaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestPlaceMutation(baseOptions?: Apollo.MutationHookOptions<GQLCreateTestPlaceMutation, GQLCreateTestPlaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLCreateTestPlaceMutation, GQLCreateTestPlaceMutationVariables>(CreateTestPlaceDocument, options);
      }
export type CreateTestPlaceMutationHookResult = ReturnType<typeof useCreateTestPlaceMutation>;
export type CreateTestPlaceMutationResult = Apollo.MutationResult<GQLCreateTestPlaceMutation>;
export type CreateTestPlaceMutationOptions = Apollo.BaseMutationOptions<GQLCreateTestPlaceMutation, GQLCreateTestPlaceMutationVariables>;
export const UpdateTestPlaceDocument = gql`
    mutation updateTestPlace($input: UpdateTestPlaceInput!) {
  updateTestPlace(input: $input) {
    ...FullTestPlace
    testDates {
      ...FullTestDate
    }
  }
}
    ${FullTestPlaceFragmentDoc}
${FullTestDateFragmentDoc}`;
export type GQLUpdateTestPlaceMutationFn = Apollo.MutationFunction<GQLUpdateTestPlaceMutation, GQLUpdateTestPlaceMutationVariables>;

/**
 * __useUpdateTestPlaceMutation__
 *
 * To run a mutation, you first call `useUpdateTestPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestPlaceMutation, { data, loading, error }] = useUpdateTestPlaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestPlaceMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTestPlaceMutation, GQLUpdateTestPlaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTestPlaceMutation, GQLUpdateTestPlaceMutationVariables>(UpdateTestPlaceDocument, options);
      }
export type UpdateTestPlaceMutationHookResult = ReturnType<typeof useUpdateTestPlaceMutation>;
export type UpdateTestPlaceMutationResult = Apollo.MutationResult<GQLUpdateTestPlaceMutation>;
export type UpdateTestPlaceMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTestPlaceMutation, GQLUpdateTestPlaceMutationVariables>;
export const DeleteTestPlaceDocument = gql`
    mutation deleteTestPlace($input: DeleteTestPlaceInput!) {
  deleteTestPlace(input: $input) {
    ...FullTestPlace
    testDates {
      ...FullTestDate
    }
  }
}
    ${FullTestPlaceFragmentDoc}
${FullTestDateFragmentDoc}`;
export type GQLDeleteTestPlaceMutationFn = Apollo.MutationFunction<GQLDeleteTestPlaceMutation, GQLDeleteTestPlaceMutationVariables>;

/**
 * __useDeleteTestPlaceMutation__
 *
 * To run a mutation, you first call `useDeleteTestPlaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestPlaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestPlaceMutation, { data, loading, error }] = useDeleteTestPlaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTestPlaceMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteTestPlaceMutation, GQLDeleteTestPlaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteTestPlaceMutation, GQLDeleteTestPlaceMutationVariables>(DeleteTestPlaceDocument, options);
      }
export type DeleteTestPlaceMutationHookResult = ReturnType<typeof useDeleteTestPlaceMutation>;
export type DeleteTestPlaceMutationResult = Apollo.MutationResult<GQLDeleteTestPlaceMutation>;
export type DeleteTestPlaceMutationOptions = Apollo.BaseMutationOptions<GQLDeleteTestPlaceMutation, GQLDeleteTestPlaceMutationVariables>;
export const DeleteTestPlacesDocument = gql`
    mutation deleteTestPlaces($input: DeleteTestPlacesInput!) {
  deleteTestPlaces(input: $input) {
    ...FullTestPlace
    testDates {
      ...FullTestDate
    }
  }
}
    ${FullTestPlaceFragmentDoc}
${FullTestDateFragmentDoc}`;
export type GQLDeleteTestPlacesMutationFn = Apollo.MutationFunction<GQLDeleteTestPlacesMutation, GQLDeleteTestPlacesMutationVariables>;

/**
 * __useDeleteTestPlacesMutation__
 *
 * To run a mutation, you first call `useDeleteTestPlacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestPlacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestPlacesMutation, { data, loading, error }] = useDeleteTestPlacesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTestPlacesMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteTestPlacesMutation, GQLDeleteTestPlacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteTestPlacesMutation, GQLDeleteTestPlacesMutationVariables>(DeleteTestPlacesDocument, options);
      }
export type DeleteTestPlacesMutationHookResult = ReturnType<typeof useDeleteTestPlacesMutation>;
export type DeleteTestPlacesMutationResult = Apollo.MutationResult<GQLDeleteTestPlacesMutation>;
export type DeleteTestPlacesMutationOptions = Apollo.BaseMutationOptions<GQLDeleteTestPlacesMutation, GQLDeleteTestPlacesMutationVariables>;
export const CreateTestDateDocument = gql`
    mutation createTestDate($input: CreateTestDateInput!) {
  createTestDate(input: $input) {
    ...FullTestDate
  }
}
    ${FullTestDateFragmentDoc}`;
export type GQLCreateTestDateMutationFn = Apollo.MutationFunction<GQLCreateTestDateMutation, GQLCreateTestDateMutationVariables>;

/**
 * __useCreateTestDateMutation__
 *
 * To run a mutation, you first call `useCreateTestDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestDateMutation, { data, loading, error }] = useCreateTestDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestDateMutation(baseOptions?: Apollo.MutationHookOptions<GQLCreateTestDateMutation, GQLCreateTestDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLCreateTestDateMutation, GQLCreateTestDateMutationVariables>(CreateTestDateDocument, options);
      }
export type CreateTestDateMutationHookResult = ReturnType<typeof useCreateTestDateMutation>;
export type CreateTestDateMutationResult = Apollo.MutationResult<GQLCreateTestDateMutation>;
export type CreateTestDateMutationOptions = Apollo.BaseMutationOptions<GQLCreateTestDateMutation, GQLCreateTestDateMutationVariables>;
export const CreateTestDatesDocument = gql`
    mutation createTestDates($input: CreateTestDatesInput!) {
  createTestDates(input: $input) {
    ...FullTestDate
  }
}
    ${FullTestDateFragmentDoc}`;
export type GQLCreateTestDatesMutationFn = Apollo.MutationFunction<GQLCreateTestDatesMutation, GQLCreateTestDatesMutationVariables>;

/**
 * __useCreateTestDatesMutation__
 *
 * To run a mutation, you first call `useCreateTestDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestDatesMutation, { data, loading, error }] = useCreateTestDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestDatesMutation(baseOptions?: Apollo.MutationHookOptions<GQLCreateTestDatesMutation, GQLCreateTestDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLCreateTestDatesMutation, GQLCreateTestDatesMutationVariables>(CreateTestDatesDocument, options);
      }
export type CreateTestDatesMutationHookResult = ReturnType<typeof useCreateTestDatesMutation>;
export type CreateTestDatesMutationResult = Apollo.MutationResult<GQLCreateTestDatesMutation>;
export type CreateTestDatesMutationOptions = Apollo.BaseMutationOptions<GQLCreateTestDatesMutation, GQLCreateTestDatesMutationVariables>;
export const UpdateTestDateDocument = gql`
    mutation updateTestDate($input: UpdateTestDateInput!) {
  updateTestDate(input: $input) {
    ...FullTestDate
  }
}
    ${FullTestDateFragmentDoc}`;
export type GQLUpdateTestDateMutationFn = Apollo.MutationFunction<GQLUpdateTestDateMutation, GQLUpdateTestDateMutationVariables>;

/**
 * __useUpdateTestDateMutation__
 *
 * To run a mutation, you first call `useUpdateTestDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestDateMutation, { data, loading, error }] = useUpdateTestDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestDateMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTestDateMutation, GQLUpdateTestDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTestDateMutation, GQLUpdateTestDateMutationVariables>(UpdateTestDateDocument, options);
      }
export type UpdateTestDateMutationHookResult = ReturnType<typeof useUpdateTestDateMutation>;
export type UpdateTestDateMutationResult = Apollo.MutationResult<GQLUpdateTestDateMutation>;
export type UpdateTestDateMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTestDateMutation, GQLUpdateTestDateMutationVariables>;
export const UpdateTestDatesDocument = gql`
    mutation updateTestDates($input: UpdateTestDatesInput!) {
  updateTestDates(input: $input) {
    ...FullTestDate
  }
}
    ${FullTestDateFragmentDoc}`;
export type GQLUpdateTestDatesMutationFn = Apollo.MutationFunction<GQLUpdateTestDatesMutation, GQLUpdateTestDatesMutationVariables>;

/**
 * __useUpdateTestDatesMutation__
 *
 * To run a mutation, you first call `useUpdateTestDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestDatesMutation, { data, loading, error }] = useUpdateTestDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestDatesMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateTestDatesMutation, GQLUpdateTestDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateTestDatesMutation, GQLUpdateTestDatesMutationVariables>(UpdateTestDatesDocument, options);
      }
export type UpdateTestDatesMutationHookResult = ReturnType<typeof useUpdateTestDatesMutation>;
export type UpdateTestDatesMutationResult = Apollo.MutationResult<GQLUpdateTestDatesMutation>;
export type UpdateTestDatesMutationOptions = Apollo.BaseMutationOptions<GQLUpdateTestDatesMutation, GQLUpdateTestDatesMutationVariables>;
export const DeleteTestdateDocument = gql`
    mutation deleteTestdate($input: DeleteTestDateInput!) {
  deleteTestDate(input: $input) {
    ...FullTestDate
  }
}
    ${FullTestDateFragmentDoc}`;
export type GQLDeleteTestdateMutationFn = Apollo.MutationFunction<GQLDeleteTestdateMutation, GQLDeleteTestdateMutationVariables>;

/**
 * __useDeleteTestdateMutation__
 *
 * To run a mutation, you first call `useDeleteTestdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestdateMutation, { data, loading, error }] = useDeleteTestdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTestdateMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteTestdateMutation, GQLDeleteTestdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteTestdateMutation, GQLDeleteTestdateMutationVariables>(DeleteTestdateDocument, options);
      }
export type DeleteTestdateMutationHookResult = ReturnType<typeof useDeleteTestdateMutation>;
export type DeleteTestdateMutationResult = Apollo.MutationResult<GQLDeleteTestdateMutation>;
export type DeleteTestdateMutationOptions = Apollo.BaseMutationOptions<GQLDeleteTestdateMutation, GQLDeleteTestdateMutationVariables>;
export const DeleteTestdatesDocument = gql`
    mutation deleteTestdates($input: DeleteTestDatesInput!) {
  deleteTestDates(input: $input)
}
    `;
export type GQLDeleteTestdatesMutationFn = Apollo.MutationFunction<GQLDeleteTestdatesMutation, GQLDeleteTestdatesMutationVariables>;

/**
 * __useDeleteTestdatesMutation__
 *
 * To run a mutation, you first call `useDeleteTestdatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestdatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestdatesMutation, { data, loading, error }] = useDeleteTestdatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTestdatesMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteTestdatesMutation, GQLDeleteTestdatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteTestdatesMutation, GQLDeleteTestdatesMutationVariables>(DeleteTestdatesDocument, options);
      }
export type DeleteTestdatesMutationHookResult = ReturnType<typeof useDeleteTestdatesMutation>;
export type DeleteTestdatesMutationResult = Apollo.MutationResult<GQLDeleteTestdatesMutation>;
export type DeleteTestdatesMutationOptions = Apollo.BaseMutationOptions<GQLDeleteTestdatesMutation, GQLDeleteTestdatesMutationVariables>;
export const RegisterServiceCodesDocument = gql`
    mutation registerServiceCodes($input: RegisterServiceCodesInput!) {
  registerServiceCodes(input: $input) {
    ...ServiceCode
  }
}
    ${ServiceCodeFragmentDoc}`;
export type GQLRegisterServiceCodesMutationFn = Apollo.MutationFunction<GQLRegisterServiceCodesMutation, GQLRegisterServiceCodesMutationVariables>;

/**
 * __useRegisterServiceCodesMutation__
 *
 * To run a mutation, you first call `useRegisterServiceCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterServiceCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerServiceCodesMutation, { data, loading, error }] = useRegisterServiceCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterServiceCodesMutation(baseOptions?: Apollo.MutationHookOptions<GQLRegisterServiceCodesMutation, GQLRegisterServiceCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLRegisterServiceCodesMutation, GQLRegisterServiceCodesMutationVariables>(RegisterServiceCodesDocument, options);
      }
export type RegisterServiceCodesMutationHookResult = ReturnType<typeof useRegisterServiceCodesMutation>;
export type RegisterServiceCodesMutationResult = Apollo.MutationResult<GQLRegisterServiceCodesMutation>;
export type RegisterServiceCodesMutationOptions = Apollo.BaseMutationOptions<GQLRegisterServiceCodesMutation, GQLRegisterServiceCodesMutationVariables>;
export const DeleteServiceCodesDocument = gql`
    mutation deleteServiceCodes($input: DeleteServiceCodesInput!) {
  deleteServiceCodes(input: $input)
}
    `;
export type GQLDeleteServiceCodesMutationFn = Apollo.MutationFunction<GQLDeleteServiceCodesMutation, GQLDeleteServiceCodesMutationVariables>;

/**
 * __useDeleteServiceCodesMutation__
 *
 * To run a mutation, you first call `useDeleteServiceCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceCodesMutation, { data, loading, error }] = useDeleteServiceCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteServiceCodesMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteServiceCodesMutation, GQLDeleteServiceCodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteServiceCodesMutation, GQLDeleteServiceCodesMutationVariables>(DeleteServiceCodesDocument, options);
      }
export type DeleteServiceCodesMutationHookResult = ReturnType<typeof useDeleteServiceCodesMutation>;
export type DeleteServiceCodesMutationResult = Apollo.MutationResult<GQLDeleteServiceCodesMutation>;
export type DeleteServiceCodesMutationOptions = Apollo.BaseMutationOptions<GQLDeleteServiceCodesMutation, GQLDeleteServiceCodesMutationVariables>;
export const UpdateEntryTestDateDocument = gql`
    mutation updateEntryTestDate($input: UpdateEntryTestDateInput!) {
  updateEntryTestDate(input: $input) {
    ...TestDate
  }
}
    ${TestDateFragmentDoc}`;
export type GQLUpdateEntryTestDateMutationFn = Apollo.MutationFunction<GQLUpdateEntryTestDateMutation, GQLUpdateEntryTestDateMutationVariables>;

/**
 * __useUpdateEntryTestDateMutation__
 *
 * To run a mutation, you first call `useUpdateEntryTestDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntryTestDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntryTestDateMutation, { data, loading, error }] = useUpdateEntryTestDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEntryTestDateMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateEntryTestDateMutation, GQLUpdateEntryTestDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateEntryTestDateMutation, GQLUpdateEntryTestDateMutationVariables>(UpdateEntryTestDateDocument, options);
      }
export type UpdateEntryTestDateMutationHookResult = ReturnType<typeof useUpdateEntryTestDateMutation>;
export type UpdateEntryTestDateMutationResult = Apollo.MutationResult<GQLUpdateEntryTestDateMutation>;
export type UpdateEntryTestDateMutationOptions = Apollo.BaseMutationOptions<GQLUpdateEntryTestDateMutation, GQLUpdateEntryTestDateMutationVariables>;
export const CreateCouponCodeDocument = gql`
    mutation createCouponCode($input: CreateCouponCodeInput!) {
  createCouponCode(input: $input) {
    ...CouponCode
  }
}
    ${CouponCodeFragmentDoc}`;
export type GQLCreateCouponCodeMutationFn = Apollo.MutationFunction<GQLCreateCouponCodeMutation, GQLCreateCouponCodeMutationVariables>;

/**
 * __useCreateCouponCodeMutation__
 *
 * To run a mutation, you first call `useCreateCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponCodeMutation, { data, loading, error }] = useCreateCouponCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<GQLCreateCouponCodeMutation, GQLCreateCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLCreateCouponCodeMutation, GQLCreateCouponCodeMutationVariables>(CreateCouponCodeDocument, options);
      }
export type CreateCouponCodeMutationHookResult = ReturnType<typeof useCreateCouponCodeMutation>;
export type CreateCouponCodeMutationResult = Apollo.MutationResult<GQLCreateCouponCodeMutation>;
export type CreateCouponCodeMutationOptions = Apollo.BaseMutationOptions<GQLCreateCouponCodeMutation, GQLCreateCouponCodeMutationVariables>;
export const UpdateCouponCodeDocument = gql`
    mutation updateCouponCode($input: UpdateCouponCodeInput!) {
  updateCouponCode(input: $input) {
    ...CouponCode
  }
}
    ${CouponCodeFragmentDoc}`;
export type GQLUpdateCouponCodeMutationFn = Apollo.MutationFunction<GQLUpdateCouponCodeMutation, GQLUpdateCouponCodeMutationVariables>;

/**
 * __useUpdateCouponCodeMutation__
 *
 * To run a mutation, you first call `useUpdateCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCouponCodeMutation, { data, loading, error }] = useUpdateCouponCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<GQLUpdateCouponCodeMutation, GQLUpdateCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLUpdateCouponCodeMutation, GQLUpdateCouponCodeMutationVariables>(UpdateCouponCodeDocument, options);
      }
export type UpdateCouponCodeMutationHookResult = ReturnType<typeof useUpdateCouponCodeMutation>;
export type UpdateCouponCodeMutationResult = Apollo.MutationResult<GQLUpdateCouponCodeMutation>;
export type UpdateCouponCodeMutationOptions = Apollo.BaseMutationOptions<GQLUpdateCouponCodeMutation, GQLUpdateCouponCodeMutationVariables>;
export const DeleteCouponCodeDocument = gql`
    mutation deleteCouponCode($input: DeleteCouponCodeInput!) {
  deleteCouponCode(input: $input) {
    ...CouponCode
  }
}
    ${CouponCodeFragmentDoc}`;
export type GQLDeleteCouponCodeMutationFn = Apollo.MutationFunction<GQLDeleteCouponCodeMutation, GQLDeleteCouponCodeMutationVariables>;

/**
 * __useDeleteCouponCodeMutation__
 *
 * To run a mutation, you first call `useDeleteCouponCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponCodeMutation, { data, loading, error }] = useDeleteCouponCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCouponCodeMutation(baseOptions?: Apollo.MutationHookOptions<GQLDeleteCouponCodeMutation, GQLDeleteCouponCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GQLDeleteCouponCodeMutation, GQLDeleteCouponCodeMutationVariables>(DeleteCouponCodeDocument, options);
      }
export type DeleteCouponCodeMutationHookResult = ReturnType<typeof useDeleteCouponCodeMutation>;
export type DeleteCouponCodeMutationResult = Apollo.MutationResult<GQLDeleteCouponCodeMutation>;
export type DeleteCouponCodeMutationOptions = Apollo.BaseMutationOptions<GQLDeleteCouponCodeMutation, GQLDeleteCouponCodeMutationVariables>;
export const EntriesDocument = gql`
    query entries($input: EntriesInput!) {
  entries(input: $input) {
    nodes {
      ...Entry
      testDate {
        ...FullTestDate
        testPlace {
          ...FullTestPlace
        }
      }
      lastTestPlace {
        ...FullTestPlace
      }
    }
    count
  }
}
    ${EntryFragmentDoc}
${FullTestDateFragmentDoc}
${FullTestPlaceFragmentDoc}`;

/**
 * __useEntriesQuery__
 *
 * To run a query within a React component, call `useEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEntriesQuery(baseOptions: Apollo.QueryHookOptions<GQLEntriesQuery, GQLEntriesQueryVariables> & ({ variables: GQLEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLEntriesQuery, GQLEntriesQueryVariables>(EntriesDocument, options);
      }
export function useEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLEntriesQuery, GQLEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLEntriesQuery, GQLEntriesQueryVariables>(EntriesDocument, options);
        }
export function useEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLEntriesQuery, GQLEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLEntriesQuery, GQLEntriesQueryVariables>(EntriesDocument, options);
        }
export type EntriesQueryHookResult = ReturnType<typeof useEntriesQuery>;
export type EntriesLazyQueryHookResult = ReturnType<typeof useEntriesLazyQuery>;
export type EntriesSuspenseQueryHookResult = ReturnType<typeof useEntriesSuspenseQuery>;
export type EntriesQueryResult = Apollo.QueryResult<GQLEntriesQuery, GQLEntriesQueryVariables>;
export const TestPlacesDocument = gql`
    query testPlaces {
  testPlaces {
    ...TestPlace
  }
}
    ${TestPlaceFragmentDoc}`;

/**
 * __useTestPlacesQuery__
 *
 * To run a query within a React component, call `useTestPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestPlacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTestPlacesQuery(baseOptions?: Apollo.QueryHookOptions<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>(TestPlacesDocument, options);
      }
export function useTestPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>(TestPlacesDocument, options);
        }
export function useTestPlacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>(TestPlacesDocument, options);
        }
export type TestPlacesQueryHookResult = ReturnType<typeof useTestPlacesQuery>;
export type TestPlacesLazyQueryHookResult = ReturnType<typeof useTestPlacesLazyQuery>;
export type TestPlacesSuspenseQueryHookResult = ReturnType<typeof useTestPlacesSuspenseQuery>;
export type TestPlacesQueryResult = Apollo.QueryResult<GQLTestPlacesQuery, GQLTestPlacesQueryVariables>;
export const TestDatesDocument = gql`
    query testDates($testPlaceId: ID) {
  testDates(testPlaceId: $testPlaceId) {
    ...TestDate
  }
}
    ${TestDateFragmentDoc}`;

/**
 * __useTestDatesQuery__
 *
 * To run a query within a React component, call `useTestDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestDatesQuery({
 *   variables: {
 *      testPlaceId: // value for 'testPlaceId'
 *   },
 * });
 */
export function useTestDatesQuery(baseOptions?: Apollo.QueryHookOptions<GQLTestDatesQuery, GQLTestDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLTestDatesQuery, GQLTestDatesQueryVariables>(TestDatesDocument, options);
      }
export function useTestDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLTestDatesQuery, GQLTestDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLTestDatesQuery, GQLTestDatesQueryVariables>(TestDatesDocument, options);
        }
export function useTestDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLTestDatesQuery, GQLTestDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLTestDatesQuery, GQLTestDatesQueryVariables>(TestDatesDocument, options);
        }
export type TestDatesQueryHookResult = ReturnType<typeof useTestDatesQuery>;
export type TestDatesLazyQueryHookResult = ReturnType<typeof useTestDatesLazyQuery>;
export type TestDatesSuspenseQueryHookResult = ReturnType<typeof useTestDatesSuspenseQuery>;
export type TestDatesQueryResult = Apollo.QueryResult<GQLTestDatesQuery, GQLTestDatesQueryVariables>;
export const FullTestPlacesDocument = gql`
    query fullTestPlaces {
  fullTestPlaces {
    ...FullTestPlace
  }
}
    ${FullTestPlaceFragmentDoc}`;

/**
 * __useFullTestPlacesQuery__
 *
 * To run a query within a React component, call `useFullTestPlacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTestPlacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTestPlacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFullTestPlacesQuery(baseOptions?: Apollo.QueryHookOptions<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>(FullTestPlacesDocument, options);
      }
export function useFullTestPlacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>(FullTestPlacesDocument, options);
        }
export function useFullTestPlacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>(FullTestPlacesDocument, options);
        }
export type FullTestPlacesQueryHookResult = ReturnType<typeof useFullTestPlacesQuery>;
export type FullTestPlacesLazyQueryHookResult = ReturnType<typeof useFullTestPlacesLazyQuery>;
export type FullTestPlacesSuspenseQueryHookResult = ReturnType<typeof useFullTestPlacesSuspenseQuery>;
export type FullTestPlacesQueryResult = Apollo.QueryResult<GQLFullTestPlacesQuery, GQLFullTestPlacesQueryVariables>;
export const FullTestPlacesWithTestDatesDocument = gql`
    query fullTestPlacesWithTestDates {
  fullTestPlaces {
    ...FullTestPlace
    testDates {
      ...FullTestDate
    }
  }
}
    ${FullTestPlaceFragmentDoc}
${FullTestDateFragmentDoc}`;

/**
 * __useFullTestPlacesWithTestDatesQuery__
 *
 * To run a query within a React component, call `useFullTestPlacesWithTestDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTestPlacesWithTestDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTestPlacesWithTestDatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFullTestPlacesWithTestDatesQuery(baseOptions?: Apollo.QueryHookOptions<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>(FullTestPlacesWithTestDatesDocument, options);
      }
export function useFullTestPlacesWithTestDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>(FullTestPlacesWithTestDatesDocument, options);
        }
export function useFullTestPlacesWithTestDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>(FullTestPlacesWithTestDatesDocument, options);
        }
export type FullTestPlacesWithTestDatesQueryHookResult = ReturnType<typeof useFullTestPlacesWithTestDatesQuery>;
export type FullTestPlacesWithTestDatesLazyQueryHookResult = ReturnType<typeof useFullTestPlacesWithTestDatesLazyQuery>;
export type FullTestPlacesWithTestDatesSuspenseQueryHookResult = ReturnType<typeof useFullTestPlacesWithTestDatesSuspenseQuery>;
export type FullTestPlacesWithTestDatesQueryResult = Apollo.QueryResult<GQLFullTestPlacesWithTestDatesQuery, GQLFullTestPlacesWithTestDatesQueryVariables>;
export const FullTestDatesDocument = gql`
    query fullTestDates($testPlaceId: ID) {
  fullTestDates(testPlaceId: $testPlaceId) {
    ...FullTestDate
  }
}
    ${FullTestDateFragmentDoc}`;

/**
 * __useFullTestDatesQuery__
 *
 * To run a query within a React component, call `useFullTestDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullTestDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullTestDatesQuery({
 *   variables: {
 *      testPlaceId: // value for 'testPlaceId'
 *   },
 * });
 */
export function useFullTestDatesQuery(baseOptions?: Apollo.QueryHookOptions<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>(FullTestDatesDocument, options);
      }
export function useFullTestDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>(FullTestDatesDocument, options);
        }
export function useFullTestDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>(FullTestDatesDocument, options);
        }
export type FullTestDatesQueryHookResult = ReturnType<typeof useFullTestDatesQuery>;
export type FullTestDatesLazyQueryHookResult = ReturnType<typeof useFullTestDatesLazyQuery>;
export type FullTestDatesSuspenseQueryHookResult = ReturnType<typeof useFullTestDatesSuspenseQuery>;
export type FullTestDatesQueryResult = Apollo.QueryResult<GQLFullTestDatesQuery, GQLFullTestDatesQueryVariables>;
export const ServiceCodesDocument = gql`
    query serviceCodes($input: ServiceCodesInput!) {
  serviceCodes(input: $input) {
    count
    nodes {
      ...ServiceCode
    }
  }
}
    ${ServiceCodeFragmentDoc}`;

/**
 * __useServiceCodesQuery__
 *
 * To run a query within a React component, call `useServiceCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useServiceCodesQuery(baseOptions: Apollo.QueryHookOptions<GQLServiceCodesQuery, GQLServiceCodesQueryVariables> & ({ variables: GQLServiceCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLServiceCodesQuery, GQLServiceCodesQueryVariables>(ServiceCodesDocument, options);
      }
export function useServiceCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLServiceCodesQuery, GQLServiceCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLServiceCodesQuery, GQLServiceCodesQueryVariables>(ServiceCodesDocument, options);
        }
export function useServiceCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLServiceCodesQuery, GQLServiceCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLServiceCodesQuery, GQLServiceCodesQueryVariables>(ServiceCodesDocument, options);
        }
export type ServiceCodesQueryHookResult = ReturnType<typeof useServiceCodesQuery>;
export type ServiceCodesLazyQueryHookResult = ReturnType<typeof useServiceCodesLazyQuery>;
export type ServiceCodesSuspenseQueryHookResult = ReturnType<typeof useServiceCodesSuspenseQuery>;
export type ServiceCodesQueryResult = Apollo.QueryResult<GQLServiceCodesQuery, GQLServiceCodesQueryVariables>;
export const IsValidServiceCodeDocument = gql`
    query isValidServiceCode($input: IsValidServiceCodeInput!) {
  isValidServiceCode(input: $input)
}
    `;

/**
 * __useIsValidServiceCodeQuery__
 *
 * To run a query within a React component, call `useIsValidServiceCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsValidServiceCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsValidServiceCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsValidServiceCodeQuery(baseOptions: Apollo.QueryHookOptions<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables> & ({ variables: GQLIsValidServiceCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables>(IsValidServiceCodeDocument, options);
      }
export function useIsValidServiceCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables>(IsValidServiceCodeDocument, options);
        }
export function useIsValidServiceCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables>(IsValidServiceCodeDocument, options);
        }
export type IsValidServiceCodeQueryHookResult = ReturnType<typeof useIsValidServiceCodeQuery>;
export type IsValidServiceCodeLazyQueryHookResult = ReturnType<typeof useIsValidServiceCodeLazyQuery>;
export type IsValidServiceCodeSuspenseQueryHookResult = ReturnType<typeof useIsValidServiceCodeSuspenseQuery>;
export type IsValidServiceCodeQueryResult = Apollo.QueryResult<GQLIsValidServiceCodeQuery, GQLIsValidServiceCodeQueryVariables>;
export const EntryTestDateDocument = gql`
    query entryTestDate($input: EntryTestDateInput!) {
  entryTestDate(input: $input) {
    ...TestDate
    testPlace {
      ...TestPlace
    }
  }
}
    ${TestDateFragmentDoc}
${TestPlaceFragmentDoc}`;

/**
 * __useEntryTestDateQuery__
 *
 * To run a query within a React component, call `useEntryTestDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntryTestDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntryTestDateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEntryTestDateQuery(baseOptions: Apollo.QueryHookOptions<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables> & ({ variables: GQLEntryTestDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables>(EntryTestDateDocument, options);
      }
export function useEntryTestDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables>(EntryTestDateDocument, options);
        }
export function useEntryTestDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables>(EntryTestDateDocument, options);
        }
export type EntryTestDateQueryHookResult = ReturnType<typeof useEntryTestDateQuery>;
export type EntryTestDateLazyQueryHookResult = ReturnType<typeof useEntryTestDateLazyQuery>;
export type EntryTestDateSuspenseQueryHookResult = ReturnType<typeof useEntryTestDateSuspenseQuery>;
export type EntryTestDateQueryResult = Apollo.QueryResult<GQLEntryTestDateQuery, GQLEntryTestDateQueryVariables>;
export const CouponCodeDocument = gql`
    query couponCode($input: CouponCodeInput!) {
  couponCode(input: $input) {
    ...CouponCode
  }
}
    ${CouponCodeFragmentDoc}`;

/**
 * __useCouponCodeQuery__
 *
 * To run a query within a React component, call `useCouponCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouponCodeQuery(baseOptions: Apollo.QueryHookOptions<GQLCouponCodeQuery, GQLCouponCodeQueryVariables> & ({ variables: GQLCouponCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLCouponCodeQuery, GQLCouponCodeQueryVariables>(CouponCodeDocument, options);
      }
export function useCouponCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLCouponCodeQuery, GQLCouponCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLCouponCodeQuery, GQLCouponCodeQueryVariables>(CouponCodeDocument, options);
        }
export function useCouponCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLCouponCodeQuery, GQLCouponCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLCouponCodeQuery, GQLCouponCodeQueryVariables>(CouponCodeDocument, options);
        }
export type CouponCodeQueryHookResult = ReturnType<typeof useCouponCodeQuery>;
export type CouponCodeLazyQueryHookResult = ReturnType<typeof useCouponCodeLazyQuery>;
export type CouponCodeSuspenseQueryHookResult = ReturnType<typeof useCouponCodeSuspenseQuery>;
export type CouponCodeQueryResult = Apollo.QueryResult<GQLCouponCodeQuery, GQLCouponCodeQueryVariables>;
export const CouponCodesDocument = gql`
    query couponCodes($input: CouponCodesInput!) {
  couponCodes(input: $input) {
    ...FullCouponCode
  }
}
    ${FullCouponCodeFragmentDoc}`;

/**
 * __useCouponCodesQuery__
 *
 * To run a query within a React component, call `useCouponCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponCodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouponCodesQuery(baseOptions: Apollo.QueryHookOptions<GQLCouponCodesQuery, GQLCouponCodesQueryVariables> & ({ variables: GQLCouponCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLCouponCodesQuery, GQLCouponCodesQueryVariables>(CouponCodesDocument, options);
      }
export function useCouponCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLCouponCodesQuery, GQLCouponCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLCouponCodesQuery, GQLCouponCodesQueryVariables>(CouponCodesDocument, options);
        }
export function useCouponCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLCouponCodesQuery, GQLCouponCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLCouponCodesQuery, GQLCouponCodesQueryVariables>(CouponCodesDocument, options);
        }
export type CouponCodesQueryHookResult = ReturnType<typeof useCouponCodesQuery>;
export type CouponCodesLazyQueryHookResult = ReturnType<typeof useCouponCodesLazyQuery>;
export type CouponCodesSuspenseQueryHookResult = ReturnType<typeof useCouponCodesSuspenseQuery>;
export type CouponCodesQueryResult = Apollo.QueryResult<GQLCouponCodesQuery, GQLCouponCodesQueryVariables>;
export const SettingDocument = gql`
    query setting($input: SettingInput!) {
  setting(input: $input) {
    ...Setting
  }
}
    ${SettingFragmentDoc}`;

/**
 * __useSettingQuery__
 *
 * To run a query within a React component, call `useSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingQuery(baseOptions: Apollo.QueryHookOptions<GQLSettingQuery, GQLSettingQueryVariables> & ({ variables: GQLSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GQLSettingQuery, GQLSettingQueryVariables>(SettingDocument, options);
      }
export function useSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GQLSettingQuery, GQLSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GQLSettingQuery, GQLSettingQueryVariables>(SettingDocument, options);
        }
export function useSettingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GQLSettingQuery, GQLSettingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GQLSettingQuery, GQLSettingQueryVariables>(SettingDocument, options);
        }
export type SettingQueryHookResult = ReturnType<typeof useSettingQuery>;
export type SettingLazyQueryHookResult = ReturnType<typeof useSettingLazyQuery>;
export type SettingSuspenseQueryHookResult = ReturnType<typeof useSettingSuspenseQuery>;
export type SettingQueryResult = Apollo.QueryResult<GQLSettingQuery, GQLSettingQueryVariables>;